import { AxiosResponse } from "axios";
import { request } from "../../../utils";

export const getAllInsurances = (): Promise<AxiosResponse<any>> => {
  const req = request();
  return req.get("/api/v1/insurances");
};
